import type { IconProps } from '../types/IconProps.ts';
export const LayoutList: IconProps = {
    name: 'LayoutList',
    children: [
        `<rect width="7" height="7" x="3" y="3" rx="1" />`,
        `<rect width="7" height="7" x="3" y="14" rx="1" />`,
        `<path d="M14 20h7M14 15h7M14 9h7M14 4h7" />`,
    ]
};